// Usage:
//
// const actionCreators = createFetchActionCreators({
//   loadActionType: BUSINESS_FROM_ID_LOAD,
//   failureActionType: BUSINESS_FROM_ID_FAILURE,
//   successActionType: BUSINESS_FROM_ID_SUCCESS
// })
//
// export function getBusinessFromId (id) {
//   return {
//     ...actionCreators,
//     requestParams: {
//       url: `/client/businesses/${id}`
//     },
//     type: FETCH
//   }
// }
export function createLoadActionCreator(actionType) {
    return (payload) => ({
        payload,
        type: actionType,
    });
}
export function createFailureActionCreator(actionType) {
    return (error, payload) => ({
        error,
        payload,
        type: actionType,
    });
}
export function createSuccessActionCreator(actionType) {
    return (data, payload) => ({
        data,
        payload,
        type: actionType,
    });
}
export const createFetchActionCreators = function createFetchActionCreators({ loadActionType, failureActionType, successActionType, } = {}) {
    return {
        loadActionCreator: loadActionType ? createLoadActionCreator(loadActionType) : undefined,
        failureActionCreator: failureActionType ? createFailureActionCreator(failureActionType) : undefined,
        successActionCreator: successActionType ? createSuccessActionCreator(successActionType) : undefined,
    };
};
//# sourceMappingURL=create-fetch-action-creators.js.map